module.exports = __webpack_public_path__ + "4a427c73c3a5da75a41a5187c37b27ea.svg";